import React from 'react'
import { motion } from "framer-motion";
const Heading = ({subHeading, heading, detail}) => {
    
    const textVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };
  return (
     <div className="max-w-6xl mx-auto px-4 w-[100%] lg:w-[60%] md:w-[80%] text-center">
                {/* Heading */}
                <motion.h4 
                    className="font-outfit text-sm  md:text-base text-[#555]"
                    variants={textVariants}
                >
                    {subHeading}
                </motion.h4>
                
                <motion.h2 
                    className="font-cinzel mt-[1rem] mb-[1rem] text-[25px] md:text-[40px] lg:text-[60px] text-[#000] mt-1 mb-3"
                    variants={textVariants}
                >
                    {heading}
                </motion.h2>
                
                <motion.p 
                    className="font-outfit text-sm md:text-base text-[#555]"
                    variants={textVariants}
                >
                    {detail}
                </motion.p>
                </div>
  
  )
}

export default Heading
